import { useState, useRef } from 'react';
import StarRating from '../components/StarRating';

export default function Recensies() {
  const [recensies, setRecensies] = useState([
    { naam: 'Sanne', sterren: 5, tekst: 'Super service en prachtig resultaat!' },
    { naam: 'Tom', sterren: 4, tekst: 'Snelle levering en goed contact.' },
  ]);
  const [naam, setNaam] = useState('');
  const [sterren, setSterren] = useState(0);
  const [tekst, setTekst] = useState('');
  const formRef = useRef();

  function handleSubmit(e) {
    e.preventDefault();
    if (naam && sterren && tekst) {
      setRecensies([{ naam, sterren, tekst }, ...recensies]);
      // Stuur recensie via mailto
      const subject = encodeURIComponent('Nieuwe recensie op Prints by Jeroen');
      const body = encodeURIComponent(`Naam: ${naam}\nSterren: ${sterren}\nRecensie: ${tekst}`);
      window.open(`mailto:jeroenmeijs@hotmail.com?subject=${subject}&body=${body}`);
      setNaam('');
      setSterren(0);
      setTekst('');
    }
  }

  return (
    <div className="min-h-screen bg-gray-50" style={{ background: 'var(--color-bg)', color: 'var(--color-text)' }}>
      <div className="container-custom section max-w-2xl mx-auto">
        <div className="card mb-10">
          <h1 className="text-3xl font-bold mb-6 text-accent1">Recensies</h1>
          <form onSubmit={handleSubmit} className="mb-10" ref={formRef}>
            <label className="block mb-2 font-medium">Jouw naam</label>
            <input value={naam} onChange={e => setNaam(e.target.value)} className="input w-full mb-4" required />
            <label className="block mb-2 font-medium">Jouw beoordeling</label>
            <StarRating value={sterren} onChange={setSterren} />
            <label className="block mb-2 font-medium mt-2">Jouw ervaring</label>
            <textarea value={tekst} onChange={e => setTekst(e.target.value)} className="input w-full mb-4" rows={3} required />
            <button type="submit" className="btn-primary px-6 py-3 text-lg w-full">Plaats recensie</button>
          </form>
          <div className="space-y-8">
            {recensies.map((r, i) => (
              <div key={i} className="card bg-grey bg-opacity-30 rounded-lg p-4 border border-grey">
                <div className="flex items-center gap-2 mb-1">
                  <span className="font-bold text-accent2">{r.naam}</span>
                  <span className="text-accent2">{'★'.repeat(r.sterren)}{'☆'.repeat(5 - r.sterren)}</span>
                </div>
                <div className="text-base">{r.tekst}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
} 